<template>
  <div>
    <header id="list-section" class="homapt-header bottom-margin" v-bind:style="backgroundImage">
      <div class="dark-overlay">
        <div class="container-fluid">
          <!--<div class="row">
            <div class="col-lg">
              <h1 class="overlay-text overlay-text-top">Looking to Buy or Sell Your Home?</h1>
              <h3 class="overlay-text overlay-text-bottom">Get full-service experience for only 1.5% listing fee!</h3>
            </div>
          </div>-->
          <div class="row top-padding">
            <div class="col-lg-8 offset-lg-2 text-center">
              <h1 class="overlay-text overlay-text-top">List Your House With HomApt Today And Save!</h1>
              <router-link to="/contact">
                <button class="btn btn-primary contact-us">Contact Us</button>
              </router-link>
              <p class="overlay-text overlay-text-bottom">Find out more about what HomApt agents can do for you. With no obligation, our experienced Agents will contact you within the hour to discuss your time line, needs and next steps. Why wait? Contact us today!</p>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container bottom-margin">
      <div class="row">
        <div class="col-sm-4">
          <img src="/static/KatiePhoto.jpg" alt="Katie Photo" class="realtor-portrait">
        </div>
        <div class="col-sm-8">
          <h2 class="mb-5">Meet your local Realtor</h2>
          <h2 class="mb-3">Katie is available in your neighborhood!</h2>
          <p>Have a question about real estate? Interested in buying or selling a home? Katie can help you! Download the HomApt Realty App and start messaging directly with Katie about your questions. Or, ask a question below and receive an email reply within 2 hours.</p>
          <h2>Ask Katie a question!</h2>
          <textarea v-model="question"
            class="form-control form-control-md mb-3"
            placeholder="I would like to know more!"
            v-bind:class="{'is-invalid': questionInvalid}"
            rows="4"></textarea>
          <button class="btn btn-primary question-button" v-on:click="showQuestionModal">Ask Now!</button>
          <b-modal id="questionModal" ref="questionModal" size="lg" hide-footer class="homapt-question-modal">
            <div slot="modal-header" class="w-100 justify-content-center">
              <button v-on:click="hideQuestionModal" class="close d-inline" type="button" aria-label="Close">x</button>
              <div class="container">
                <div class="row">
                  <div class="col text-center">
                    <h3 class="m-0 question">Ask A Question</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row form-row">
                <div class="col-md-3 text-right my-auto">
                  <p class="mb-0">Name<span class="red-text" v-if="!name">*</span></p>
                </div>
                <div class="col-md-9 my-auto">
                  <input v-model="name"
                    class="form-control form-control-md"
                    placeholder="Enter your name"
                    v-bind:class="{'is-invalid': nameInvalid}">
                  <div class="invalid-feedback">
                    Please enter a name
                  </div>
                </div>
              </div>
              <div class="row form-row">
                <div class="col-md-3 text-right my-auto">
                  <p class="mb-0">Email<span class="red-text" v-if="!email">*</span></p>
                </div>
                <div class="col-md-9 my-auto">
                  <input v-model="email"
                    class="form-control form-control-md"
                    placeholder="Enter an email"
                    v-bind:class="{'is-invalid': emailInvalid}">
                  <div class="invalid-feedback">
                    Please enter a valid email address
                  </div>
                </div>
              </div>
              <div class="row form-row">
                <div class="col-md-3 text-right my-auto">
                  <p class="mb-0">Question<span class="red-text" v-if="!question">*</span></p>
                </div>
                <div class="col-md-9">
                  <textarea v-model="question"
                    class="form-control form-control-md"
                    placeholder="I would like to know more!"
                    v-bind:class="{'is-invalid': questionInvalid}"
                    rows="4"></textarea>
                  <div class="invalid-feedback">
                    Please enter a question
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4 offset-2">
                  <button type="button" class="btn btn-secondary full-btn" v-on:click="hideQuestionModal">Cancel</button>
                </div>
                <div class="col-4">
                  <button type="button" class="btn btn-primary" v-on:click="submitQuestion">Send</button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row blue-banner top-blue">
        <div class="col-4 text-center my-auto">
          <i class="fas fa-city"></i>
        </div>
        <div class="col-4 text-center my-auto">
          <i class="far fa-building"></i>
        </div>
        <div class="col-4 text-center my-auto">
          <i class="fas fa-warehouse"></i>
        </div>
      </div>
      <div class="row blue-banner">
        <div class="col-2 offset-2 text-center my-auto">
          <i class="fas fa-home"></i>
        </div>
        <div class="col-4 text-center my-auto">
          <h3 class="blue-text">HomApt Experience</h3>
        </div>
        <div class="col-2 text-center my-auto">
          <i class="fas fa-shower"></i>
        </div>
      </div>
      <div class="row blue-banner">
        <div class="col-4 text-center my-auto">
          <i class="fas fa-door-open"></i>
        </div>
        <div class="col-4 text-center my-auto">
          <i class="fas fa-bed"></i>
        </div>
        <div class="col-4 text-center my-auto">
          <i class="fas fa-building"></i>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row experience-row">
        <div class="col-lg my-auto text-center">
          <img src="/static/Laptop.1size.small.png" class="homapt-hme-icon" alt="something" height='auto' width="400px">
        </div>
        <div class="col-lg my-auto">
          <h2 class="subtitle">Full Service Experience</h2>
          <ul>
            <li>Incorporating new technology for ultimate listing exposure</li>
            <li>One-Stop-Shop for your home selling process</li>
            <li>Experienced agents that know your neighborhood</li>
          </ul>
          <router-link to="/profsupport">
            <button type="button" class="btn btn-secondary learn-more-button">Learn more</button>
          </router-link>
        </div>
      </div>
      <hr>
      <div class="row experience-row">
        <div class="col-lg text-center second my-auto">
          <img src="/static/HouseIcon.1size.Small.png" class="homapt-hme-icon" alt="something" height='auto' width="400px">
        </div>
        <div class="col-lg my-auto">
          <h2 class="subtitle">Low Cost and Effective</h2>
          <ul>
            <li>Average homeowner saves 50% on realtor fees when listing with HomApt*</li>
            <li>Save thousands of dollars and get professional experience</li>
            <li>Reduce the paperwork and automate your listing</li>
          </ul>
          <router-link to="/savetimemoney">
            <button type="button" class="btn btn-secondary learn-more-button">Learn more</button>
          </router-link>
        </div>
      </div>
      <hr>
      <div class="row experience-row">
        <div class="col-lg text-center my-auto">
          <img src="/static/SupportIcon.1size.Small.png" class="homapt-hme-icon" alt="something" height='auto' width="400px">
        </div>
        <div class="col-lg my-auto">
          <h2 class="subtitle">Professional Expertise</h2>
          <ul>
            <li>Certified HomApt Realtors are available 24/7</li>
            <li>Ensuring your home sells in a timely manner</li>
            <li>Get the price you deserve</li>
          </ul>
          <router-link to="/profsupport">
            <button type="button" class="btn btn-secondary learn-more-button">Learn more</button>
          </router-link>
        </div>
      </div>
      <hr>
      <div class="row experience-row bottom-margin">
        <div class="col-lg my-auto text-center second">
          <img src="/static/NetworkIcon.1size.Small.png" class="homapt-hme-icon" alt="something" height='auto' width="400px">
        </div>
        <div class="col-lg my-auto">
          <h2 class="subtitle">Get Noticed</h2>
          <ul>
            <li>Publish your listing directly on HomApt to millions of users</li>
            <li>HomApt will also publish your listing to the MLS for optimal exposure</li>
            <li>Expert photographers will show your home's beauty</li>
          </ul>
          <router-link to="/profsupport">
            <button type="button" class="btn btn-secondary learn-more-button">Learn more</button>
          </router-link>
        </div>
      </div>
    </div>
    <!--<div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 my-auto text-center">
            <h2>Interested in Home Concierge Services?</h2>
            <p class="text-left">Whether you are selling your home or just trying to keep up maintenance, HomApt's Marketplace will help you get there. See home service reviews, find coupons, and get a quote fast.</p>
            <b-button to="marketplace" type="button" class="btn btn-secondary">Marketplace</b-button>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Buy and Sell',
    meta: [
      { vmid: 'description', content: 'Buy and sell your house with HomApt.' }
    ]
  },
  data () {
    return {
      name: null,
      nameInvalid: false,
      email: null,
      emailInvalid: false,
      question: null,
      questionInvalid: false,
      formInvalid: false
    }
  },
  methods: {
    showQuestionModal () {
      this.$refs.questionModal.show()
    },
    hideQuestionModal () {
      this.$refs.questionModal.hide()
    },
    validate () {
      this.formInvalid = false

      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(this.email)) {
        this.emailInvalid = true
        this.formInvalid = true
      } else {
        this.emailInvalid = false
      }

      if (!this.name) {
        this.nameInvalid = true
        this.formInvalid = true
      } else {
        this.nameInvalid = false
      }

      if (!this.question) {
        this.questionInvalid = true
        this.formInvalid = true
      } else {
        this.questionInvalid = false
      }
    },
    async submitQuestion () {
      this.validate()
      if (this.formInvalid) return
      var client = this.$store.getters.getEmailApigClientFactory
      var params = {}
      var pathTemplate = '/question'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        email: this.email,
        name: this.name,
        question: this.question
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.hideQuestionModal()
        this.$bvToast.show('my-toast')
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    backgroundImage () {
      return 'background-image: url("https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xlarge/uploads/276-POM7597-Nam.jpg")'
    }
  }
}
</script>

<style scoped>
.bottom-margin {
  margin-bottom: 6rem;
}

.contact-us {
  width: 250px !important;
}

.container-fluid {
  height: 100%;
}

.fas, .far {
  font-size: 30px;
  color: white;
}

.top-blue {
  margin-top: 2rem;
}

.blue-text {
  color: #feedaa !important;
}

.blue-banner {
  height: 130px;
  background-color: #363e4a;
}

.full-btn {
  width: 100% !important;
}

.overlay-text-top {
  padding-top: 3rem;
}

.overlay-text {
  padding-left: 3rem;
}

.overlay-text-bottom {
  padding-top: 0;
}

.contact-section {
  padding-bottom: 4rem;
}

.contact-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.form-padding {
  margin-top: .4rem;
}

.form-row {
  margin-bottom: 1rem;
}

#list-section {
  /*going to need to dynamically select this*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top !important;
}

.experience-row {
  padding-bottom: 1rem;
}

@media (min-width: 992px) {
  .second {
    -ms-flex-order: 2;
    order: 2;
  }
}

@media (max-width: 992px) {
  .learn-more-button {
    width: 100% !important;
    margin-left: unset !important;
  }
}

.question {
  padding-left: 3.3rem;
  padding-top: 1rem;
}

hr {
  border-width: 3px;
}

.needs-padding {
  padding-top: 2rem;
}

@media (min-width: 768px) {
  .question-button {
    width: 30% !important;
  }
}

ul {
  margin: 15px;
  padding: 0;
}

.subtitle {
  padding-top: 1rem;
}

.learn-more-button {
  margin-left: 1rem;
}

ul {
  margin-left: 1rem;
}

.realtor-portrait {
  height: auto;
  width: auto;
}

.top-padding {
  padding-top: 12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/realty/RealtyPage.vue